import { Component, OnInit } from '@angular/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable, Subscription } from 'rxjs';
import { filter, map, shareReplay, switchMap } from 'rxjs/operators';
import { ArticleService } from '../../../core/catalog';
import {
  ArticleCarouselActionMode,
  ArticleCarouselItem,
  ArticleReferences,
  ArticlesTileComponent,
  ProductsTilesDisplayModes,
} from '../../../core/model';
import { PrincipalConfigurationService } from '../../../core/user';
import { hasCmsStyleClass, hasNoCmsTitleClass } from '../../../shared';
import { CmsFeaturedArticlesService } from './base/services';

@Component({
  selector: 'py-articles-tiles',
  templateUrl: './articles-tiles.component.html',
  styleUrls: ['./articles-tiles.component.scss'],
  standalone: false,
})
export class ArticlesTilesComponent implements OnInit {
  componentData$: Observable<ArticlesTileComponent>;
  articleRefs$: Observable<string[]>;
  subscriptions = new Subscription();
  displayModeSlider = ProductsTilesDisplayModes.Slider;
  articles$: Observable<ArticleCarouselItem[]>;
  carouselActionModes: typeof ArticleCarouselActionMode = ArticleCarouselActionMode;
  enableSecondaryArticleRowVariant$: Observable<boolean>;

  constructor(
    public component: CmsComponentData<ArticlesTileComponent>,
    private cmsFeaturedArticlesService: CmsFeaturedArticlesService,
    private articleService: ArticleService,
    private principalConfigurationService: PrincipalConfigurationService
  ) {}

  ngOnInit(): void {
    this.componentData$ = this.component.data$.pipe(shareReplay({ bufferSize: 1, refCount: true }));
    this.enableSecondaryArticleRowVariant$ = this.principalConfigurationService
      .isEnabled('enableSecondaryArticleRowVariant')
      .pipe(shareReplay({ bufferSize: 1, refCount: true }));

    this.articleRefs$ = this.componentData$.pipe(
      filter((data: ArticlesTileComponent) => !!data?.uid),
      switchMap((data: ArticlesTileComponent) => this.cmsFeaturedArticlesService.getFeaturedArticlesReferences(data.uid)),
      map((response: ArticleReferences) => (response?.articleRefs || []).map((articleRef) => articleRef?.code)),
      shareReplay({ bufferSize: 1, refCount: true })
    );

    this.articles$ = this.articleRefs$.pipe(
      switchMap((refs) => this.articleService.getArticlesFully(refs)),
      map((articles) =>
        articles.map((article) => ({
          article,
        }))
      )
    );
  }

  getHasClass(styleClass: string, classes: string): boolean {
    return hasCmsStyleClass(styleClass, classes);
  }

  getHasNoTitleClass(classes: string): boolean {
    return hasNoCmsTitleClass(classes);
  }
}
